import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import users from "../../users";
import {preferencesStore} from "./preferences/preferencesStore";
import auth from "../../../utils/authentication";

const useUserPreferences = () => {
    const loadingUser = useSelector(users.selectors.isLoading);
    const [prefs, setPrefs] = useState(preferencesStore.state);
    const [loading, setLoading] = useState(preferencesStore.isLoading);
    const [customClaims, setCustomClaims] = useState<any>(null);
    const [loadingUpdate, setLoadingUpdate] = useState(false);

    useEffect(() => {
        const unsub = preferencesStore.subscribe(p => {
            setPrefs(p);
            setLoading(preferencesStore.isLoading);
        });

        return () => unsub();
    }, []);

    useEffect(() => {
        if (loadingUser) return;

        const user = auth.currentUser;

        if (!user?.uid) {
            preferencesStore.clear();
            setCustomClaims(null);
            return;
        }

        user.getIdTokenResult().then(res => setCustomClaims(res.claims));

        if (preferencesStore.currentUserId !== user.uid) {
            preferencesStore.fetch(user.uid);
        }
    }, [loadingUser]);

    const updatePreference = async (key: string, value: any) => {
        setLoadingUpdate(true);
        await preferencesStore.updatePreference(key, value);
        setLoadingUpdate(false);
    };

    return {
        userPreferences: prefs,
        loading,
        updatePreference,
        loadingUpdate,
        customClaims
    };
};

export default useUserPreferences;
